import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["skeleton"]

  connect() {
    this.boundShowSkeleton = this.showSkeleton.bind(this)
    this.boundHideSkeleton = this.hideSkeleton.bind(this)
    this.boundHideOnStreamRender = this.hideOnStreamRender.bind(this)
    this.boundShowOnSubmitStart = this.showOnSubmitStart.bind(this)
    this.boundHideOnSubmitEnd = this.hideOnSubmitEnd.bind(this)

    this.frame = document.querySelector('turbo-frame#sidebar-body')
    if (this.frame) {
      this.frame.addEventListener('turbo:before-fetch-request', this.boundShowSkeleton)
      this.frame.addEventListener('turbo:frame-render', this.boundHideSkeleton)
      this.frame.addEventListener('turbo:frame-load', this.boundHideSkeleton)
    }

    document.addEventListener('turbo:load', this.boundHideSkeleton)
    document.addEventListener('turbo:render', this.boundHideSkeleton)
    document.addEventListener('turbo:before-stream-render', this.boundHideOnStreamRender)
    document.addEventListener('turbo:submit-start', this.boundShowOnSubmitStart)
    document.addEventListener('turbo:submit-end', this.boundHideOnSubmitEnd)

    this.hideSkeleton()
  }

  disconnect() {
    if (this.frame) {
      this.frame.removeEventListener('turbo:before-fetch-request', this.boundShowSkeleton)
      this.frame.removeEventListener('turbo:frame-render', this.boundHideSkeleton)
      this.frame.removeEventListener('turbo:frame-load', this.boundHideSkeleton)
    }
    document.removeEventListener('turbo:load', this.boundHideSkeleton)
    document.removeEventListener('turbo:render', this.boundHideSkeleton)
    document.removeEventListener('turbo:before-stream-render', this.boundHideOnStreamRender)
    document.removeEventListener('turbo:submit-start', this.boundShowOnSubmitStart)
    document.removeEventListener('turbo:submit-end', this.boundHideOnSubmitEnd)
  }

  showSkeleton(event) {
    const fetchOptions = event.detail?.fetchOptions
    const headers = fetchOptions?.headers
    const turboFrame = headers?.['Turbo-Frame']

    if (turboFrame && turboFrame !== 'sidebar-body') {
      return
    }

    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.remove('d-none')
    }
    if (this.frame) {
      this.frame.classList.add('sidebar-loading')
    }
  }

  hideOnStreamRender(event) {
    const target = event.target?.getAttribute('target')
    if (target === 'sidebar-body') {
      requestAnimationFrame(() => this.hideSkeleton())
    }
  }

  showOnSubmitStart(event) {
    const submitter = event.detail?.formSubmission?.submitter
    const turboFrame = submitter?.getAttribute('data-turbo-frame')
    if (turboFrame === 'sidebar-body') {
      if (this.hasSkeletonTarget) {
        this.skeletonTarget.classList.remove('d-none')
      }
      this.refreshFrame()
      if (this.frame) {
        this.frame.classList.add('sidebar-loading')
      }
    }
  }

  hideOnSubmitEnd(event) {
    const submitter = event.detail?.formSubmission?.submitter
    const turboFrame = submitter?.getAttribute('data-turbo-frame')
    if (turboFrame === 'sidebar-body' || turboFrame === '_top') {
      requestAnimationFrame(() => this.hideSkeleton())
    }
  }

  hideSkeleton() {
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.add('d-none')
    }
    this.refreshFrame()
    if (this.frame) {
      this.frame.classList.remove('sidebar-loading')
    }
  }

  refreshFrame() {
    this.frame = document.querySelector('turbo-frame#sidebar-body')
  }
}
